import horseRunning from "../../public/images/horse-running-large.gif";
import pure from "../components/higher-order/pure";
import React from "react";

export default pure(function LoadingModal() {
  return (
    <div className="loading loading--fullscreen">
      <div className="loading_content">
        <div>
          <span className="loading_heading">
            Loading Game
          </span>

          <ul className="loading_ellipsis">
            <li />

            <li />

            <li />
          </ul>
        </div>

        <div className="opacity--is-75">
          Good luck!
        </div>

        <img className="loading_gif" src={horseRunning} />
      </div>
    </div>
  );
});
